import React from "react";
import web from '../src/images/s1.png';
// import {NavLink} from 'react-router-dom'; 
import Common from "./Common";
const About =() =>{
    return(
        <>
            <Common name='Welcome To The About Page' imgsrc={web} visit="/contact" btname="Contact Now"/>
        </>
    );
}

export default About;